import { configureStore } from "@reduxjs/toolkit";

import notificationSlice from "./ticketFilter/notificationSlice.js";
import userSlice from "./ticketFilter/userSlice.js";
import dropSlice from "./ticketFilter/dropSlice.js";


export const store=configureStore({
    reducer:{
        ticketFilter:userSlice,
        notification:notificationSlice,
        drop:dropSlice
    }
})

